export default __webpack_public_path__ + "static/17-b0d6319f321d1c5821f41494cdbde5a3.png";